<template>
  <div>
    <div class="tabs-container">
      <div class="items">
        <div
          v-for="(item, index) in activeItems"
          :key="index"
          class="item"
          :class="{'active': index === current}"
        >
          <div @click="goTo(index)">
            {{ $t(item.title) }}
          </div>
        </div>
      </div>
      <div
        v-if="items[current].actions"
        class="actions"
      >
        <component
          :is="action"
          v-for="(action, index) in items[current].actions"
          :key="index"
          v-model="extData"
          class="action"
          :event="event"
          :formOptions="formOptions"
        />
      </div>
    </div>
    <div class="container">
      <div
        v-for="(item, index) in activeItems"
        v-show="current === index"
        :key="index"
      >
        <component
          :is="item.comp"
          :ref="index"
          v-model="extData"
          :formOptions="formOptions"
          :event="event"
        />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import Vue from 'vue'
import { mapGetters } from 'vuex'
import Sites from '../Sites'
import Tender from '../Tender'
import ITQ from '../ITQ'
import Threshold from '../Threshold'
import Users from '../Users'
import ECircularTemplate from '../ECircularTemplate'
import ECircularCategories from '../ECircularCategories/index.vue'

const departmentComponent = {
  ECircularTemplate,
  ECircularCategories,
  Sites,
  Users,
}
const tenderComponent = {
  Tender,
  ITQ,
  Threshold,
}
const items = [
  { title: 'settings.department.tabTitles.sites', comp: departmentComponent.Sites },
  { title: 'settings.department.tabTitles.tenderGeneralDocument', comp: tenderComponent.Tender },
  { title: 'settings.department.tabTitles.ITQGeneralDocuments', comp: tenderComponent.ITQ },
  { title: 'settings.department.tabTitles.threshold', comp: tenderComponent.Threshold },
  { title: 'settings.department.tabTitles.departmentUsers', comp: departmentComponent.Users },
  { title: 'settings.department.tabTitles.eCircularTemplate', comp: departmentComponent.ECircularTemplate },
  { title: 'settings.department.tabTitles.eCircularCategories', comp: departmentComponent.ECircularCategories },
]

export default {
  name: 'TabCards',
  model: {
    prop: 'extData',
    event: 'onChange',
  },
  props: {
    formOptions: {
      type: Object,
      default: () => ({}),
    },
    extData: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      current: 0,
      items,
      event: new Vue(),
    }
  },
  computed: {
    ...mapGetters('regions', ['enableTenderFeature']),
    activeItems () {
      if (!this.enableTenderFeature) return this.items.filter(item => !Object.values(tenderComponent).includes(item.comp))
      return this.items
    },
  },
  methods: {
    goTo (index) {
      if (this.current === index) return
      this.current = index
    },
    async save () {
      const p = _.map(this.$refs, async (item) => {
        const component = item[0]
        if (component.save && typeof component.save === 'function') {
          return component.save()
        } else {
          return true
        }
      })
      await Promise.all(p)
    },
  },
}
</script>
<style scoped lang="scss">
.tabs-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  margin-top: 20px;
  width: 100%;
  .items {
    display: flex;
    flex-direction: row;
    .item {
      color: #0C3A58;
      font-weight: bold;
      text-align: center;
      min-width: 130px;
      height: 50px;
      margin-left: 10px;
      padding-left: 10px;
      padding-right: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      &.active {
        border-bottom: 2px solid #0C3A58;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .actions {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.container {
  margin-bottom: 50px;
  padding: 20px;
  background-color: #e4e4e4;
}
</style>
